import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Storefront from "@/pages/Storefront";
import AuthPage from "@/pages/AuthPage";
import AuthCallback from "@/pages/AuthCallback";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminCampaigns from "@/pages/AdminCampaigns";
import AdminAnalytics from "@/pages/AdminAnalytics";
import AdminOrders from "@/pages/AdminOrders";
import AdminDiscountCodes from "@/pages/AdminDiscountCodes";
import AdminPushNotifications from "@/pages/AdminPushNotifications";
import AdminReviews from "@/pages/AdminReviews";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import ProductLanding from "@/pages/ProductLanding";
import MagazineLanding from "@/pages/MagazineLanding";
import MagazineSuccess from "@/pages/MagazineSuccess";
import AdminSubscriptions from "@/pages/AdminSubscriptions";
import AdminUsers from "@/pages/AdminUsers";
import AdminLayout from "@/components/AdminLayout";
import ProtectedRoute from "@/components/ProtectedRoute";
import { trackPageView } from "@/lib/tracking";

function PageTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);
  return null;
}

function AppRouter() {
  const location = useLocation();
  // Check URL fragment for session_id synchronously (prevents race conditions)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <>
      <PageTracker />
      <Routes>
        <Route path="/" element={<Storefront />} />
        <Route path="/product/:campaignId" element={<ProductLanding />} />
        <Route path="/magazine" element={<MagazineLanding />} />
        <Route path="/magazine/success" element={<MagazineSuccess />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/checkout/success" element={<CheckoutSuccess />} />
        <Route path="/admin" element={<ProtectedRoute requireStaff><AdminLayout /></ProtectedRoute>}>
          <Route index element={<AdminDashboard />} />
          <Route path="campaigns" element={<AdminCampaigns />} />
          <Route path="orders" element={<ProtectedRoute requireAdmin><AdminOrders /></ProtectedRoute>} />
          <Route path="subscriptions" element={<ProtectedRoute requireAdmin><AdminSubscriptions /></ProtectedRoute>} />
          <Route path="users" element={<ProtectedRoute requireAdmin><AdminUsers /></ProtectedRoute>} />
          <Route path="discount-codes" element={<AdminDiscountCodes />} />
          <Route path="push" element={<AdminPushNotifications />} />
          <Route path="reviews" element={<AdminReviews />} />
          <Route path="analytics" element={<AdminAnalytics />} />
        </Route>
      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
